import includes from 'lodash/includes';
import {window} from 'ssr-window';
import EnvironmentUtils from '@spothero/utils/environment';

export const SearchGeocoderUtils = gmaps => ({
    _geocoder: gmaps ? new gmaps.Geocoder() : null,

    formatPlace(
        {
            /* GooglePlacesSearchInput response */
            description,
            location = {},
            place_id, // eslint-disable-line camelcase
            id,
            reference,
            /* geocoder response */
            search_string, // eslint-disable-line camelcase
            latitude,
            longitude,
            places_id, // eslint-disable-line camelcase
            places_place_id, // eslint-disable-line camelcase
            places_reference, // eslint-disable-line camelcase
        } = {},
        isPlaces = true
    ) {
        /* eslint-disable camelcase */
        const data = {
            search_string: description || search_string,
            latitude: location.lat || latitude,
            longitude: location.lng || longitude,
        };

        if (isPlaces) {
            data.google_places_id = id || places_id;
            data.google_places_place_id = place_id || places_place_id;
            data.google_places_reference = reference || places_reference;
        }
        /* eslint-enable camelcase */

        return data;
    },

    matchPlaces(address) {
        return new Promise((resolve, reject) => {
            if (!address || address.length < 3) {
                reject(new Error('Address is required to match a place'));
            }

            this._geocoder.geocode(
                {
                    address,
                },
                (res, status) => {
                    if (!res || status !== gmaps.GeocoderStatus.OK) {
                        reject(new Error('Error matching place to address'));
                    } else {
                        resolve(Promise.all(res.map(this.getAddressData)));
                    }
                }
            );
        });
    },

    getAddressData(geocodeData) {
        const {
            address_components: addressComponents,
            formatted_address: formattedAddress,
            geometry,
            id,
            place_id: placeId,
            reference,
        } = geocodeData;
        const data = {
            search_string: formattedAddress, // eslint-disable-line camelcase
            latitude: geometry ? geometry.location.lat() : null,
            longitude: geometry ? geometry.location.lng() : null,
            places_id: id, // eslint-disable-line camelcase
            places_place_id: placeId, // eslint-disable-line camelcase
            places_reference: reference, // eslint-disable-line camelcase
        };

        if (addressComponents) {
            addressComponents.forEach(item => {
                if (includes(item.types, 'street_number')) {
                    if (!('street' in data)) {
                        data.street = item.long_name;
                    } else {
                        data.street = `${item.long_name} ${data.street}`;
                    }
                } else if (includes(item.types, 'route')) {
                    if (!('street' in data)) {
                        data.street = item.long_name;
                    } else {
                        data.street = `${data.street} ${item.long_name}`;
                    }
                } else if (includes(item.types, 'locality')) {
                    data.city = item.long_name;
                } else if (
                    includes(item.types, 'administrative_area_level_1')
                ) {
                    data.state = item.short_name;
                } else if (includes(item.types, 'postal_code')) {
                    data.zipCode = item.long_name;
                }
            });
        }

        return data;
    },
});

export default SearchGeocoderUtils(
    EnvironmentUtils.isBrowser() ? window.google.maps : null
);
